// extracted by mini-css-extract-plugin
module.exports = {"root":"CardList_root__14psI","form":"CardList_form__2LsXx"};